import React, { PropTypes, Component } from 'react'
import { translate } from 'react-i18next'
import styled from 'styled-components'
import ThemeContainer from '../../components/ThemeContainer'
import { Metrics } from '../../Themes'

const CustomThemeContainer = styled(ThemeContainer)`
  max-height: calc(100vh - ${Metrics.components.navbarDefault});
  overflow-y: scroll;
`

class ProfileSettings extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: this.props.user
    }
  }

  render () {
    const { children, user } = this.props
    return (
      <CustomThemeContainer>
        {children &&
          React.cloneElement(children, {
            user: user,
            handleUpdate: this.handleUpdate
          })}
      </CustomThemeContainer>
    )
  }
}

ProfileSettings.propTypes = {
  user: PropTypes.object,
  children: PropTypes.node
}

export default translate([ 'common', 'settings' ], { wait: true })(
  ProfileSettings
)



// WEBPACK FOOTER //
// ./src/pages/ProfileSettings/index.js